import { IAttachmentToAgreementDTO } from '@user/store/attachments'
import React, { useCallback } from 'react'
import Box from '@mui/material/Box'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { useAttachmentData } from '@user/components/Attachments/AddAttachmentsDrawer/hooks'
import { FilePreview, FilePreviewMimeTypeIcon } from '@workwave-tidal/lab'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import Typography from '@mui/material/Typography'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import { useFormikContext } from 'formik'
import { CreateAgreementFormPacketModel } from './typings'

type Props = {
  attachment: IAttachmentToAgreementDTO
  index: number
}

export function DraggableAttachmentCard(props: Props) {
  const { attachment, index } = props
  const { getMimeTypeFromFileName } = useAttachmentData()
  const { formatDate } = useLocalizationDateFormat()

  const { setValues } = useFormikContext<CreateAgreementFormPacketModel>()

  const handleDeleteScAttachment = useCallback(() => {
    setValues((v) => {
      const templates = [...v.templates]
      templates.splice(index, 1)

      return { ...v, templates }
    })
  }, [index, setValues])

  return (
    <Box
      sx={{
        display: 'flex',
        pb: 1.5,
        width: '100%',
        alignItems: 'center',
        backgroundColor: '#ffffff',
      }}
    >
      <DragIndicatorIcon
        fontSize="medium"
        data-test-id="DragIndicatorIcon"
        sx={{ m: '4px', cursor: 'grab' }}
      />
      <Box sx={{ width: '100%' }}>
        <FilePreview
          disabled={false}
          icon={
            <FilePreviewMimeTypeIcon
              preset={getMimeTypeFromFileName(attachment.displayName)}
            />
          }
          title={attachment.displayName}
          tooltip=""
          subtitle={
            <Box
              color={'#0E283FB2'}
              display={'flex'}
              flexDirection={'row'}
              gap={0.8}
            >
              <Typography variant="body2">
                {formatDate(attachment.createdDate)}
              </Typography>
              {attachment?.fileSize ? (
                <Typography variant="body2">
                  {' '}
                  - {attachment?.fileSize}
                </Typography>
              ) : null}
            </Box>
          }
          variant="standard"
          actionsVisibility="always"
          actions={[
            <ActionBarItem
              onClick={() => handleDeleteScAttachment()}
              key="add"
              id="add"
              data-test-id="agreement-card-attachment-delete-button"
              label="Add"
              icon={<DeleteOutline />}
            />,
          ]}
        />
      </Box>
    </Box>
  )
}
